import request from '@/utils/request'

/**
 * 获取事件类型列表
 * @param {{ currentPage?: number, pageSize?: number, code?: string, level?: string, system?: string, module?: string }} params
 */
export function getEventTypeList(params) {
  return request({
    url: 'event/type',
    method: 'get',
    params
  })
}

/**
 * 获取事件类型详情
 * @param {number} id 事件类型 ID
 */
export function getEventType(id) {
  return request({
    url: `event/type/${id}`,
    method: 'get'
  })
}

/**
 * 创建事件类型
 * @param {{ level: string, system: string, module: string, description?: string }} data
 */
export function createEventType(data) {
  return request({
    url: 'event/type',
    method: 'post',
    data
  })
}

/**
 * 更新事件类型
 * @param {number} id 事件类型 ID
 * @param {{ level?: string, system?: string, module?: string, description?: string }} data
 */
export function updateEventType(id, data) {
  return request({
    url: `event/type/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除事件类型（会删除所有关联的事件日志）
 * @param {number} id 事件类型 ID
 */
export function deleteEventType(id) {
  return request({
    url: `event/type/${id}`,
    method: 'delete'
  })
}
